export default __webpack_public_path__ + "static/media/twitter.6db7a226.svg";